import { render, staticRenderFns } from "./ClassReportCard.vue?vue&type=template&id=421b630a&"
import script from "./ClassReportCard.vue?vue&type=script&lang=js&"
export * from "./ClassReportCard.vue?vue&type=script&lang=js&"
import style0 from "./ClassReportCard.vue?vue&type=style&index=0&id=421b630a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports